import React from 'react'
import {
    Button,
    ButtonGroup,
    SplitButton,
    SplitButtonItem,
    ToolbarSpacer,
    DropDownButton,
    DropDownButtonItem,
    Toolbar,
    ToolbarItem,
    ToolbarSeparator,
} from '@progress/kendo-react-buttons'

const FileUpload = (props) => {
    const inputFile = React.useRef(null)
    const [file, setFile] = React.useState(null)
    const onButtonClick = () => {
        inputFile.current.click()
    }
    const onChangeFile = (event) => {
        event.stopPropagation()
        event.preventDefault()
        var file = event.target.files[0]
        let reader = new FileReader()
        reader.addEventListener(
            'load',
            function () {
                let uri = reader.result
                props.handleFile(uri)
            },
            false
        )
        if (file.type.includes('image')) {
            reader.readAsDataURL(file)
        } else {
            alert('File is not an image')
        }

        // setFile(file);
    }
    return (
        <div style={{ height: 40 }}>
            <Button icon="folder" onClick={onButtonClick} {...props}>
                {' '}
                Browse
            </Button>
            <input
                type="file"
                id="file"
                ref={inputFile}
                style={{ display: 'none' }}
                onChange={onChangeFile}
            />
        </div>
    )
}

export default FileUpload
